/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvatarSourceEnum } from './AvatarSourceEnum';
import {
    AvatarSourceEnumFromJSON,
    AvatarSourceEnumFromJSONTyped,
    AvatarSourceEnumToJSON,
} from './AvatarSourceEnum';
import type { ProjectRoleDTO } from './ProjectRoleDTO';
import {
    ProjectRoleDTOFromJSON,
    ProjectRoleDTOFromJSONTyped,
    ProjectRoleDTOToJSON,
} from './ProjectRoleDTO';
import type { ProjectCodeAccessDTO } from './ProjectCodeAccessDTO';
import {
    ProjectCodeAccessDTOFromJSON,
    ProjectCodeAccessDTOFromJSONTyped,
    ProjectCodeAccessDTOToJSON,
} from './ProjectCodeAccessDTO';
import type { ProjectVisibilityDTO } from './ProjectVisibilityDTO';
import {
    ProjectVisibilityDTOFromJSON,
    ProjectVisibilityDTOFromJSONTyped,
    ProjectVisibilityDTOToJSON,
} from './ProjectVisibilityDTO';
import type { OrganizationTypeDTO } from './OrganizationTypeDTO';
import {
    OrganizationTypeDTOFromJSON,
    OrganizationTypeDTOFromJSONTyped,
    OrganizationTypeDTOToJSON,
} from './OrganizationTypeDTO';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';

/**
 * 
 * @export
 * @interface ProjectWithRoleDTO
 */
export interface ProjectWithRoleDTO {
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    projectKey: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    displayClass?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    description?: string;
    /**
     * 
     * @type {ProjectVisibilityDTO}
     * @memberof ProjectWithRoleDTO
     */
    visibility: ProjectVisibilityDTO;
    /**
     * 
     * @type {Date}
     * @memberof ProjectWithRoleDTO
     */
    timeOfCreation: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectWithRoleDTO
     */
    lastActivity: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    organizationName: string;
    /**
     * 
     * @type {OrganizationTypeDTO}
     * @memberof ProjectWithRoleDTO
     */
    organizationType: OrganizationTypeDTO;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    backgroundUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectWithRoleDTO
     */
    featured: boolean;
    /**
     * 
     * @type {ProjectCodeAccessDTO}
     * @memberof ProjectWithRoleDTO
     */
    codeAccess: ProjectCodeAccessDTO;
    /**
     * 
     * @type {ProjectRoleDTO}
     * @memberof ProjectWithRoleDTO
     */
    userRoleInProject: ProjectRoleDTO;
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof ProjectWithRoleDTO
     */
    userRoleInOrganization?: OrganizationRoleDTO;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithRoleDTO
     */
    avatarUrl: string;
    /**
     * 
     * @type {AvatarSourceEnum}
     * @memberof ProjectWithRoleDTO
     */
    avatarSource: AvatarSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof ProjectWithRoleDTO
     */
    version: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectWithRoleDTO
     */
    archived: boolean;
}



/**
 * Check if a given object implements the ProjectWithRoleDTO interface.
 */
export function instanceOfProjectWithRoleDTO(value: object): value is ProjectWithRoleDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('projectKey' in value) || value['projectKey'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('timeOfCreation' in value) || value['timeOfCreation'] === undefined) return false;
    if (!('lastActivity' in value) || value['lastActivity'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('featured' in value) || value['featured'] === undefined) return false;
    if (!('codeAccess' in value) || value['codeAccess'] === undefined) return false;
    if (!('userRoleInProject' in value) || value['userRoleInProject'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('avatarSource' in value) || value['avatarSource'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('archived' in value) || value['archived'] === undefined) return false;
    return true;
}

export function ProjectWithRoleDTOFromJSON(json: any): ProjectWithRoleDTO {
    return ProjectWithRoleDTOFromJSONTyped(json, false);
}

export function ProjectWithRoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectWithRoleDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'projectKey': json['projectKey'],
        'name': json['name'],
        'displayClass': json['displayClass'] == null ? undefined : json['displayClass'],
        'description': json['description'] == null ? undefined : json['description'],
        'visibility': ProjectVisibilityDTOFromJSON(json['visibility']),
        'timeOfCreation': (new Date(json['timeOfCreation'])),
        'lastActivity': (new Date(json['lastActivity'])),
        'organizationName': json['organizationName'],
        'organizationType': OrganizationTypeDTOFromJSON(json['organizationType']),
        'backgroundUrl': json['backgroundUrl'] == null ? undefined : json['backgroundUrl'],
        'featured': json['featured'],
        'codeAccess': ProjectCodeAccessDTOFromJSON(json['codeAccess']),
        'userRoleInProject': ProjectRoleDTOFromJSON(json['userRoleInProject']),
        'userRoleInOrganization': json['userRoleInOrganization'] == null ? undefined : OrganizationRoleDTOFromJSON(json['userRoleInOrganization']),
        'avatarUrl': json['avatarUrl'],
        'avatarSource': AvatarSourceEnumFromJSON(json['avatarSource']),
        'version': json['version'],
        'archived': json['archived'],
    };
}

export function ProjectWithRoleDTOToJSON(value?: ProjectWithRoleDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'projectKey': value['projectKey'],
        'name': value['name'],
        'displayClass': value['displayClass'],
        'description': value['description'],
        'visibility': ProjectVisibilityDTOToJSON(value['visibility']),
        'timeOfCreation': ((value['timeOfCreation']).toISOString()),
        'lastActivity': ((value['lastActivity']).toISOString()),
        'organizationName': value['organizationName'],
        'organizationType': OrganizationTypeDTOToJSON(value['organizationType']),
        'backgroundUrl': value['backgroundUrl'],
        'featured': value['featured'],
        'codeAccess': ProjectCodeAccessDTOToJSON(value['codeAccess']),
        'userRoleInProject': ProjectRoleDTOToJSON(value['userRoleInProject']),
        'userRoleInOrganization': OrganizationRoleDTOToJSON(value['userRoleInOrganization']),
        'avatarUrl': value['avatarUrl'],
        'avatarSource': AvatarSourceEnumToJSON(value['avatarSource']),
        'version': value['version'],
        'archived': value['archived'],
    };
}

